import React, { useState, useEffect } from "react";
import api from "../../axios";
import logo from "../../assets/logo.png";
import { get_image } from "../../helper";
import { useData } from "../../DataContext";
import "./about.css";

const About = () => {
  const { cachedData, updateCachedData } = useData();
  const [abouts, setAbouts] = useState(cachedData.abouts || []);
  const [isLoading, setIsLoading] = useState(!abouts.length);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    const isCacheValid = (lastFetched) => {
      if (!lastFetched) return false;
      const now = Date.now();
      const tenMinutes = 10 * 60 * 1000;
      return now - lastFetched < tenMinutes;
    };

    const fetchData = async () => {
      const startTime = Date.now();

      try {
      

        const aboutsResponse = await api.get("/abouts", {
          params: { populate: "*" },
        });
        const newAbouts = aboutsResponse.data.data;

        setAbouts(newAbouts);
        updateCachedData({
          ...cachedData,
          abouts: newAbouts,
          lastFetched: Date.now(),
        });

        const elapsed = Date.now() - startTime;
        const remaining = Math.max(5500 - elapsed, 0);

        // 🖼️ انتظار تحميل الصور
        const waitForImages = () =>
          new Promise((resolve) => {
            const images = Array.from(document.images);
            let loadedCount = 0;

            if (images.length === 0) return resolve();

            images.forEach((img) => {
              if (img.complete) {
                loadedCount++;
                if (loadedCount === images.length) resolve();
              } else {
                img.addEventListener("load", () => {
                  loadedCount++;
                  if (loadedCount === images.length) resolve();
                });
                img.addEventListener("error", () => {
                  loadedCount++;
                  if (loadedCount === images.length) resolve();
                });
              }
            });
          });

        setTimeout(async () => {
          await waitForImages();
          setIsLoading(false);
          setFirstLoad(false);
        }, remaining);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
        setFirstLoad(false);
      }
    };

    fetchData();
  }, [cachedData, updateCachedData]);

  if (isLoading) {
    return (
      <div className="loader-container">
        <img className="loader-image" src={logo} alt="Loading..." />
      </div>
    );
  }

  return (
    <div id="about">
      {abouts.map((about) => (
        <div key={about.id} className="about-card">
          <h2>{about.attributes.title}</h2>

          {about.attributes.background_image?.data && (
            <img
              className="about-background-image"
              src={get_image(about.attributes.background_image)}
              alt={
                about.attributes.background_image.data.attributes.name ||
                "Background"
              }
              loading={firstLoad ? "eager" : "lazy"}
            />
          )}

          {about.attributes.small_descriptions?.map((item) => (
            <div key={item.id} className="small-description">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}

          <p className="formatted-text">{about.attributes.description}</p>

          <small>
            Created At:{" "}
            {new Date(about.attributes.createdAt).toLocaleDateString("en-GB")}
          </small>
        </div>
      ))}
    </div>
  );
};

export default About;
